module.exports = __webpack_public_path__ + "static/media/partial-orders-tab.71c784a7.svg";